import { SITE_CONFIG } from '@/config/site';

/**
 * Build a redirect URL to the main site with UTM tracking
 */
export function buildRedirectUrl(
  path: string,
  params: Record<string, string | undefined> = {}
): string {
  const url = new URL(path, SITE_CONFIG.TARGET_URL);
  url.searchParams.set('utm_source', SITE_CONFIG.UTM_SOURCE);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

/**
 * Redirect to the main site
 */
export function redirectToMain(
  path: string = '/',
  params: Record<string, string | undefined> = {}
): void {
  window.location.href = buildRedirectUrl(path, params);
}

/**
 * Redirect to billing page
 */
export function redirectToBilling(): void {
  redirectToMain('/billing');
}

/**
 * Redirect to video creation with params
 */
export function redirectToVideo(
  mode: 't2v' | 'i2v' | 'template2v',
  params: {
    prompt?: string;
    model?: string;
    aspect_ratio?: string;
    camera?: string;
    video_style?: string;
    reference_image?: string;
    template_id?: string;
    face_image?: string;
    prompt_enhancer?: string;
  } = {}
): void {
  redirectToMain(`/video/${mode}`, params);
}

/**
 * Redirect to image creation with params
 */
export function redirectToImage(
  mode: 't2i' | 'edit',
  params: {
    prompt?: string;
    model?: string;
    source_image?: string;
  } = {}
): void {
  redirectToMain(`/images/${mode}`, params);
}
